import React, { useEffect } from "react";
import "./Index.css";
import { useAppDispatch } from "hooks/hooks";
import {
  getAllPartnersBySearchParams,
  setSelectedIndex,
  setSelectedIndexById
} from "./scenes/Main/main.slice";
import {
  PartnerDetails,
  PartnersList,
  Toolbox,
} from "./scenes/Main/components";
import Header from "Dashboard/components/Header";
import { useLocation } from "react-router-dom";

const Partners = () => {
  const dispatch = useAppDispatch();
  const { state } = useLocation();

  useEffect(() => {
    dispatch(getAllPartnersBySearchParams({}));
    if (state) {
      dispatch(setSelectedIndexById(state.partnerId));
    } else {
      dispatch(setSelectedIndex(0));
    }
  }, [dispatch]);

  return (
    <div className="wrapper-partners">
      <div>
        <Header title="Saradnici" />
        <Toolbox />
      </div>
      <PartnersList />
      <PartnerDetails />
    </div>
  );
};

export default Partners;
